import { render, staticRenderFns } from "./GameTestingDailyGamePlay.vue?vue&type=template&id=2eb24ca7&"
import script from "./GameTestingDailyGamePlay.vue?vue&type=script&lang=js&"
export * from "./GameTestingDailyGamePlay.vue?vue&type=script&lang=js&"
import style0 from "./GameTestingDailyGamePlay.vue?vue&type=style&index=0&id=2eb24ca7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports